import React, { useState, useEffect } from 'react';
import { Checkbox, Form, Input, Spin } from 'antd';
import toast from 'react-hot-toast';
import { AddWithdrawRequestApi, GetWalletApi } from '../../../../../api/request/wallet/withdraw.js';
import LoadableButton from "../../../../../components/buttons/LoadableButton.jsx";
import { Link, useParams } from "react-router-dom";
// import Withdrawtable from "../component/Withdrawtable.jsx"

function Crypto() {
    const [form] = Form.useForm();
    const { id1, id2 } = useParams();
    const [initialValues, setInitialValues] = useState({ amount: '', thirdPartyWalletAddress: '' });
    const [isAddReqLoading, setIsAddReqLoading] = useState(false);
    const [isWalletLoading, setIsWalletLoading] = useState(false);
    const [wallet, setWallet] = useState({});

    const getWallet = async () => {
        try {
            setIsWalletLoading(true);
            let params = {
                RuleType: 4
            }
            const { data } = await GetWalletApi(id2,new URLSearchParams(params).toString());
            if (data?.success) {
                setWallet(data?.data)
            }
            setIsWalletLoading(false);
        } catch (error) {
            setIsWalletLoading(false);
        }
    }

    useEffect(() => {
        getWallet();
    }, []);


    const handleSubmit = async (values) => {
        try {
            setIsAddReqLoading(true);
            let params = {
                userId: id2,
                amount: values?.amount,
                withdrawalMethod: Number(id1),
                cryptoWalletAddress: values?.cryptoWalletAddress
            }
            const { data } = await AddWithdrawRequestApi(params);
            if (data?.success) {
                toast.success(data?.message);
                form?.resetFields();
            }
            setIsAddReqLoading(false);
        } catch (error) {
            if (error?.response?.data?.message) {
                toast.error(error?.response?.data?.message);
            }
            setIsAddReqLoading(false);
        }
    }
    return (
        <div>
            <div className='border-[2px] border-light rounded-xl pt-4 w-full'>
                {isWalletLoading ? (
                    <div className="flex justify-center flex-col my-6">
                        <Spin size="large" />
                        <p className="primary text-center mt-2">Loading...</p>
                    </div>
                ) : (
                    <div className='p-4 mb-3 grid grid-cols-2 md:grid-cols-4 gap-5 lg:divide-x'>
                        <div>
                            <div className='flex justify-center'>
                                <p className='text-base font-normal text-center pb-2'>Wallet Account No.</p>
                            </div>
                            <p className='text-xl primary font-semibold text-center mt-2'>{wallet?.walletAccountNo}</p>
                        </div>
                        <div>
                            <div className='flex justify-center'>
                                <p className='text-base font-normal text-center pb-2'>Wallet Balance</p>
                            </div>
                            <p className='text-xl primary font-semibold text-center mt-2'>$ {wallet?.walletBalance}</p>
                        </div>
                        <div>
                            <div className='flex justify-center'>
                                <p className='text-base font-normal text-center pb-2 '>Minimum Transfer</p>
                            </div>
                            <p className='text-xl primary font-semibold text-center mt-2'>$ {wallet?.minAmount || '0'}</p>
                        </div>
                        <div>
                            <div className='flex justify-center'>
                                <p className='text-base font-normal text-center pb-2 '>Maximum Transfer</p>
                            </div>
                            <p className='text-xl primary font-semibold text-center mt-2'>$ {wallet?.maxAmount || '0'}</p>
                        </div>
                    </div>
                )}
            </div>
            <div className='border-[2px] border-light rounded-xl pt-4 lg:pt-6 w-full mt-5'>
                <Form className='w-full lg:p-6 p-6' autoComplete="off" form={form} initialValues={initialValues} onFinish={handleSubmit}>
                    <div className="grid sm:grid-cols-2 lg:grid-cols-2 gap-5">
                        <div className='input-white'>
                            <label className='text-base text-[#2F2B3DCC] font-medium'>Amount In USD</label>
                            <Form.Item
                                name='amount'
                                rules={[
                                    { required: true, message: 'Please enter amount.' },
                                    {
                                        validator: (_, value) => {
                                            if (!value) {
                                                return Promise.resolve();
                                            }
                                            const amount = Number(value);
                                            if (!Number.isInteger(amount)) {
                                                return Promise.reject(new Error('Please enter a valid amount.'));
                                            }
                                            if (amount < wallet?.minAmount) {
                                                return Promise.reject(new Error(`Amount must be at least $${wallet?.minAmount}.`));
                                            }
                                            if (amount > wallet?.maxAmount) {
                                                return Promise.reject(new Error(`Amount cannot exceed $${wallet?.maxAmount}.`));
                                            }
                                            return Promise.resolve();
                                        },
                                    },
                                ]}
                            >
                                <Input type='number' placeholder="Amount in USD" className="mt-1 w-full ps-4 py-2" />
                            </Form.Item>
                        </div>
                        <div className='input-white'>
                            <label className='text-base text-[#2F2B3DCC] font-medium'>TRC20 Wallet Address</label>
                            <Form.Item name='cryptoWalletAddress' rules={[{ required: true, message: 'Please enter TRC20 Wallet Address.' }]}>
                                <Input placeholder="TRC20 Wallet Address" className="mt-1 w-full ps-4 py-2" />
                            </Form.Item>
                        </div>
                    </div>
                    <div>
                        <Form.Item name='conditions' valuePropName="checked" rules={[{ validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms and conditions.')), }]} >
                            <Checkbox className='mt-4'>Yes, I agreed to the <Link to={'/terms_&_conditions'} className='primary hover:underline duration-300'>Terms and conditions</Link></Checkbox>
                        </Form.Item>
                    </div>
                    <div className='flex items-center gap-5 mt-10'>
                        <LoadableButton
                            className='bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover duration-500'
                            disabled={isAddReqLoading}
                            type="Submit"
                            lable='Submit'
                            isLoading={isAddReqLoading}
                            loadingLable='Adding request...'
                        />
                    </div>
                </Form>
            </div>
            {/* <div>
                <Withdrawtable />
            </div> */}
        </div>
    )
}

export default Crypto
